// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--V_xFv","text":"_9e1425b4d3--text--R80o6","search-modal-wrapper":"_9e1425b4d3--search-modal-wrapper--OhPv1"};